type TSectionName = 'anchor' | 'details' | 'employment' | 'formdata' | 'history' | 'membership' | 'message' | 'permission' | 'personal' | 'positions' | 'privacy';
